// Account Creation Javascript

const AccountCreation = {
    elements: {
        accountForm: document.querySelector('#account-form'),
        inputs: []
    },
    init() {
        // Add listeners for various field types
        if (this.elements.accountForm) {
            this.elements.inputs = this.elements.accountForm.querySelectorAll('input, select');

            this.elements.inputs.forEach(field => {
                field.addEventListener('change', (event) => {
                    const fieldName = event.target.name;
                    const fieldValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
                    const formOtherElement = document.querySelector(`.js-form-other[data-field-name="${fieldName}"]`);

                    if (formOtherElement) {
                        if (event.target.type === 'checkbox') {
                            // If the field is a checkbox, check all checkboxes with the same name
                            const checkboxes = document.querySelectorAll(`input[name="${event.target.name}"]`);
                            let showFormOtherElement = false;
                            checkboxes.forEach(checkbox => {
                                if (checkbox.value === 'other' && checkbox.checked) {
                                    showFormOtherElement = true;
                                }
                            });
                            if (showFormOtherElement) {
                                formOtherElement.classList.remove('hidden');
                            } else {
                                formOtherElement.classList.add('hidden');
                            }
                        } else {
                            // If the field is not a checkbox, use the original logic
                            if (fieldValue === 'other') {
                                formOtherElement.classList.remove('hidden');
                            } else {
                                formOtherElement.classList.add('hidden');
                            }
                        }
                    }
                });
            })
        }
    },
    onSubmit(token) {
        this.elements.accountForm.submit();
    }
};

export default AccountCreation;
